
import { Vue, Component } from "vue-property-decorator";
import MaterialSelect from "@/components/material-select/index.vue";
import Upload from "@/components/ls-upload.vue";
import { apiAiConfigGet, apiAiConfigSet, apiSetArtSuggest, apiGetArtSuggest,
    apiSet3dSuggest, apiGet3dSuggest, apiDelSuggestImage, apiDelSuggestModel } from "@/api/setting";
import { Loading } from "element-ui";

@Component({
    components: {
        MaterialSelect,
    },
})

export default class MuheConfig extends Vue {
    /** S Data **/
    // 表单数据
    loading = false;
    form: any = {
        ai_default_image: "",
        ai_default_model: "",
        aiart_suggest: [],
        ai3d_suggest: [],
        aiart_wait: "",
        ai3d_wait_name: "",
        ai3d_wait_file: "",
    };
    /** E Data **/

    /** S Methods **/
    // 初始化表单数据
    async initFormData(): Promise<void> {
        const data = await apiAiConfigGet();
        this.form.ai_default_image = data.ai_default_image;
        this.form.ai_default_model = data.ai_default_model;
    }

    // 提交表单
    async onSubmitFrom(formName: string) {
        const ret = await apiAiConfigSet(this.form);
        this.initFormData();
    }

    async refreshAiArtSuggest()
    {
        const ret = await apiGetArtSuggest();
        this.form.aiart_suggest = ret.lists;
    }
    async onAiartUpload()
    {
        await apiSetArtSuggest({'aiart_wait': this.form.aiart_wait});
        this.refreshAiArtSuggest();
        this.form.aiart_wait = '';
    }
    async refreshAi3dSuggest()
    {
        const ret = await apiGet3dSuggest();
        this.form.ai3d_suggest = ret.lists;
    }
    async onAi3dUpload()
    {
        if(this.form.ai3d_wait_name == '' || this.form.ai3d_wait_file == ''){
            this.$message({
                type: 'error',
                'message': '模型文件和模型ID不能为空',
            });
            return;
        }

        this.loading = true;
        await apiSet3dSuggest({'ai3d_wait_name': this.form.ai3d_wait_name, 
                        'ai3d_wait_file': this.form.ai3d_wait_file});
        this.refreshAi3dSuggest();
        this.form.ai3d_wait_name = '';
        this.form.ai3d_wait_file = '';
        this.loading = false;
    }
    async delSuggestImage(id: number)
    {
        await apiDelSuggestImage({id});
        this.refreshAiArtSuggest();
    }
    async delSuggestModel(id: number)
    {
        await apiDelSuggestModel({id});
        this.refreshAi3dSuggest();
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.initFormData();
        this.refreshAiArtSuggest();
        this.refreshAi3dSuggest();
    }
    /** E Life Cycle **/
}
